import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { AccountFeatureService, UserRole } from "@app/services/accountFeature.service";
import { ConstantsService } from "@app/services/constantsService";
import { VTabComponent } from "@directives/_layout/v-tabs/v-tab.component";
import { IAggregateFilterEvent } from "@directives/_resourceFilters/filter-bar/filter-bar.models";
import { DateService } from "@services/date.service";
import { IVehicleWithTemperatureData } from "@temperature/_models/temperature/IVehicleWithTemperatureData";
import { InputListComponent } from "../input-list/input-list.component";
import { ProbeDetailComponent } from "../probe-detail/probe-detail.component";
import { TemperatureLogComponent } from "../temperature-log/temperature-log.component";
import './temperature-compliance-detail.component.scss';

@Component({
    selector: 'temperature-compliance-detail',
    template: require('./temperature-compliance-detail.component.html')
})
export class TemperatureComplianceDetailComponent implements OnInit {
    @Input() vehicle: IVehicleWithTemperatureData;

    //--

    start: Date;
    end: Date;

    rangeStartTime: string;
    rangeEndTime: string;

    showGraph: boolean;
    selectedTab: VTabComponent;

    isMobile: boolean;

    @ViewChild('tempLog') tempLog: TemperatureLogComponent;
    @ViewChild('inputList') inputList: InputListComponent;
    @ViewChild('probeDetail') probeDetail: ProbeDetailComponent;

    userHasHistoricalAccess: boolean;

    constructor(
        private readonly dateService: DateService,
        private readonly constantsService: ConstantsService,
        private readonly accountFeatureService: AccountFeatureService
    ) {
        this.isMobile = this.constantsService.getIsMobile();
    }

    ngOnInit(): void {
        this.userHasHistoricalAccess = this.accountFeatureService.currentUserHasRole([UserRole.History]);

        this.initDates();
    }

    onFilterChanged(event: IAggregateFilterEvent<any>): void {
        if (!event.trigger) {
            return;
        }

        if (event.trigger === 'date') {
            this.start = event.date[0];
            this.end = event.date[1];
        }
    }

    resetGraph(showGraph): void {
        this.showGraph = showGraph;
    }

    resetTables(): void {
        this.resetGraph(false);

    }

    updateSelectedTab(tab: VTabComponent): void {
        this.selectedTab = tab;
    }

    //--

    private initDates(): void {
        this.start = this.dateService.getStartOfDay(new Date());
        this.end = this.dateService.getEndOfDay(new Date());
    }
}
